import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'fcp-snackbar',
    templateUrl: './fcp-snackbar.component.html',
    styleUrls: ['./fcp-snackbar.component.less'],
    standalone: false
})
export class FcpSnackbarComponent {
    @Input() type: SnackbarType = SnackbarType.Success;
    @Input() horizontal: SnackbarHorizontalPosition = SnackbarHorizontalPosition.Center;
    @Input() vertical: SnackbarVerticalPosition = SnackbarVerticalPosition.Bottom;
    @Input() size: SnackbarSize = SnackbarSize.Responsive;
    public show = true;

    @Output() public alertClosed: EventEmitter<void>;

    constructor() {
        this.alertClosed = new EventEmitter<void>();
    }

    onClickAlertClosed() {
        this.show = false;
        this.alertClosed.emit();
    }
}

// TODO: there are other types with the same name exported in the fcp-alert component. Consider sharing these.
export enum SnackbarType {
    Warning = 'warning',
    Error = 'critical',
    Success = 'success',
    Info = 'info'
}

export enum SnackbarHorizontalPosition {
    Center = 'center',
    Left = 'left',
    Right = 'right'
}

export enum SnackbarVerticalPosition {
    Top = 'top',
    Bottom = 'bottom'
}

export enum SnackbarSize {
    Responsive = 'responsive',
    Large = 'large'
}
